import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pt-10 py-12" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-brand_blue text-4xl w-full text-center mb-6" }, "Binovative Checkup Sonucu", -1)
const _hoisted_4 = { class: "container mx-auto text-center" }
const _hoisted_5 = { class: "mb-4 block text-black px-4" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Sayın ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(", Binovative Check Up sonucunuza ait rapor hazırdır. " + " Dilerseniz, ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "DETAYLI RAPORU SATIN AL", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" butonuna tıklayıp raporunuzu indirebilirsiniz. ")
const _hoisted_10 = {
  key: 1,
  class: "text-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-black font-medium text-base mt-6" }, "Kod geçerli! Detaylı raporun indirme linki en kısa süre içinde e-posta adresinize iletilecektir.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_buy_detailed_report = _resolveComponent("buy-detailed-report")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_form = _resolveComponent("the-form")!
  const _component_check_circle_outlined = _resolveComponent("check-circle-outlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.free_code_accepted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("b", null, _toDisplayString(_ctx.session.name), 1),
              _hoisted_7,
              _hoisted_8,
              _hoisted_9
            ]),
            _createVNode(_component_buy_detailed_report, { class: "block text-center mt-10" }),
            _createVNode(_component_the_form, {
              "submit-text": 'button.submit',
              submitting: _ctx.free_code_checking,
              class: "free-code-form mx-auto mt-6 max-w-lg px-4",
              onSubmit: _ctx.useFreePass
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_input, {
                  value: _ctx.free_code,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.free_code) = $event)),
                  name: "freecode",
                  label: 'Ücretsiz İndirme Kodum Var!',
                  placeholder: _ctx.$t('common.code'),
                  type: "text",
                  class: "mb-4",
                  rules: _ctx.Yup.string().required()
                }, null, 8, ["value", "placeholder", "rules"])
              ]),
              _: 1
            }, 8, ["submit-text", "submitting", "onSubmit"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_check_circle_outlined, {
            style: { color: '#52c41a' },
            class: "text-9xl"
          }),
          _hoisted_11
        ]))
  ]))
}